export const normalizeVehicleCategory = (value?: string | null) =>
    String(value || "").trim().toUpperCase();

const COMMERCIAL_VEHICLE_CATEGORIES = new Set([
    "AUTOCARRO",
    "FURGONE",
    "PROM.",
    "PROMISCUO",
    "PROMISQUO",
]);

export const isCommercialVehicleCategory = (value?: string | null) => {
    const normalized = normalizeVehicleCategory(value);
    return COMMERCIAL_VEHICLE_CATEGORIES.has(normalized);
};

export const shouldShowNetPriceForCommercialVehicle = (
    categoria?: string | null,
    codiceIVA?: string | null,
) => isCommercialVehicleCategory(categoria) && String(codiceIVA || "").trim() === "22";
